<template>
  <div class="main-wrapper">
    <layouts></layouts>
    <sidebar></sidebar>
    <div class="page-wrapper">
      <div class="content">
        <pageheader :title="title" :title1="title1" />

        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-4 col-sm-6 col-12">
                <div class="form-group">
                  <label>Expense Category</label>
                  <select v-model="form.categoryid" class="form-control" ref="firstInput">
                    <option value="">Choose Category</option>
                    <option v-for="category in categories" :key="category.categoryid" :value="category.categoryid">
                      {{ category.categoryname }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-lg-4 col-sm-6 col-12">
                <div class="form-group">
                  <label>Expense Date</label>
                  <input v-model="form.expensedate" type="date" class="form-control" />
                </div>
              </div>
              <div class="col-lg-4 col-sm-6 col-12">
                <div class="form-group">
                  <label>Amount</label>
                  <input v-model.number="form.amount" type="number" min="0" step="0.01" class="form-control" @keypress.enter="submitForm" />
                </div>
              </div>
              <div class="col-lg-4 col-sm-6 col-12">
                <div class="form-group">
                  <label>Bill No.</label>
                  <input v-model.trim="form.billno" type="text" class="form-control" placeholder="Optional" @keypress.enter="submitForm" />
                </div>
              </div>
              <div class="col-lg-4 col-sm-6 col-12">
                <div class="form-group">
                  <label>Payment Mode</label>
                  <select v-model="form.paymentmode" class="form-control">
                    <option value="">Choose Payment Mode</option>
                    <option v-for="mode in paymentModes" :key="mode.value" :value="mode.value">{{ mode.label }}</option>
                  </select>
                </div>
              </div>
              <div class="col-lg-4 col-sm-6 col-12">
                <div class="form-group">
                  <label>Payee Name</label>
                  <input v-model.trim="form.payeename" type="text" class="form-control" @keypress.enter="submitForm" />
                </div>
              </div>
              <div class="col-lg-12">
                <div class="form-group">
                  <label>Remarks</label>
                  <textarea v-model.trim="form.remarks" class="form-control" rows="3"></textarea>
                </div>
              </div>
              <div class="col-lg-12">
                <button type="button" class="btn btn-submit me-2" @click="submitForm">Update</button>
                <router-link to="expenselist" class="btn btn-cancel">Cancel</router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

const paymentModes = [
  { value: "CASH", label: "Cash" },
  { value: "BANK_TRANSFER", label: "Bank Transfer" },
  { value: "UPI", label: "UPI" },
  { value: "CHEQUE", label: "Cheque" },
  { value: "OTHER", label: "Other" },
];

export default {
  data() {
    return {
      title: "Expense Edit",
      title1: "Update expense entry",
      expenseid: this.$route.query.id,
      categories: [],
      paymentModes,
      form: {
        categoryid: "",
        expensedate: "",
        amount: null,
        billno: "",
        paymentmode: "",
        payeename: "",
        remarks: "",
      },
    };
  },
  methods: {
    payload() {
      return {
        ...this.form,
        amount: Number(this.form.amount || 0).toFixed(2),
        billno: this.form.billno || null,
        paymentmode: this.form.paymentmode || null,
      };
    },
    validate() {
      if (!this.expenseid) return "Expense id is missing";
      if (!this.form.categoryid) return "Please choose expense category";
      if (!this.form.expensedate) return "Please choose expense date";
      if (!this.form.amount || Number(this.form.amount) <= 0) return "Please enter a valid amount";
      return null;
    },
    async submitForm() {
      const error = this.validate();
      if (error) {
        Swal.fire(error);
        return;
      }
      try {
        await axios.put(`/v1/expenses/${this.expenseid}`, this.payload());
        Swal.fire("Expense updated successfully");
        this.$router.push({ path: "/expenselist" });
      } catch (error) {
        Swal.fire(error.response?.data?.detail || "Unable to update expense");
      }
    },
    async loadCategories() {
      const response = await axios.get("/v1/expenses/categories");
      this.categories = response.data || [];
    },
    async loadExpense() {
      if (!this.expenseid) return;
      const response = await axios.get(`/v1/expenses/${this.expenseid}`);
      const expense = response.data || {};
      this.form = {
        categoryid: expense.categoryid || "",
        expensedate: expense.expensedate || "",
        amount: Number(expense.amount || 0),
        billno: expense.billno || "",
        paymentmode: expense.paymentmode || "",
        payeename: expense.payeename || "",
        remarks: expense.remarks || "",
      };
    },
  },
  async mounted() {
    await this.loadCategories();
    await this.loadExpense();
    this.$nextTick(() => this.$refs.firstInput?.focus());
  },
  name: "editexpense",
};
</script>
